/**
 * Carte de « l'Île des Défis » = LA RÉUNION (viewBox 160×120).
 * Silhouette HISTORIQUE du mockup (conservée : ses découpes de côte évoquent
 * bien La Réunion — validé utilisateur, préférée à une forme générée).
 * Partagée par IleEleve (archipel plein écran) et HomeEleve (mini-carte)
 * — UNE seule source.
 *
 * Lecture géographique de la silhouette (pour poser les ancres) :
 *  - nord ≈ (63, 6) → Saint-Denis ; ouest ≈ (20-33, 40-80) → côte sous le
 *    vent et lagon ; sud-est ≈ (100-140, 80-114) → le volcan.
 *
 * Géographie narrative (ancres en coordonnées viewBox) :
 *  - foret  : la Forêt des Mots (Roche Écrite, nord — habitat RÉEL du
 *             tuit-tuit) → région FRANÇAIS ;
 *  - volcan : le Volcan des Nombres (Piton de la Fournaise, sud-est)
 *             → région MATHS ;
 *  - piton  : le Piton des Neiges (centre) — sommet commun ;
 *  - nid    : le nid de Tano (contreforts de la Roche Écrite) — teaser
 *             des œufs (mécanique future) ;
 *  - lagon  : le lagon de l'ouest (l'Ermitage) — point de départ.
 */

export const ILE_PATH = "M26.0,55.6 L20.5,50.1 L20.3,43.9 L19.5,39.1 L22.7,36.2 L27.8,34.8 L31.6,28.0 L31.2,21.4 L31.9,20.4 L32.5,18.4 L32.2,17.9 L31.9,16.4 L38.7,17.0 L40.0,17.3 L43.9,15.7 L48.9,10.7 L55.7,6.7 L63.5,5.8 L69.7,7.8 L77.2,7.7 L84.8,10.0 L89.3,9.6 L95.1,11.3 L102.6,13.8 L109.3,18.9 L113.5,24.7 L114.4,32.8 L115.9,38.2 L120.6,42.5 L124.6,50.1 L129.7,57.0 L134.2,59.3 L137.9,61.9 L139.7,64.7 L140.7,68.0 L140.3,71.8 L139.3,74.9 L136.7,79.4 L135.1,85.6 L134.8,90.7 L135.3,95.6 L135.1,98.9 L134.6,105.2 L131.4,108.2 L128.0,109.9 L124.6,110.2 L121.1,110.6 L116.1,112.3 L110.2,112.0 L107.1,113.5 L102.8,113.9 L95.6,114.1 L92.3,111.6 L87.7,111.5 L84.6,111.6 L81.2,109.5 L76.7,107.6 L72.4,106.7 L70.0,105.4 L64.6,102.0 L58.8,100.6 L54.8,95.8 L48.7,92.8 L43.8,92.1 L41.5,88.7 L39.3,85.5 L35.9,82.5 L32.9,78.9 L31.6,75.0 L32.6,70.9 L30.4,64.3 L29.3,60.5 L26.4,57.2 L26.0,55.6 Z";

// L'île est rendue réduite autour du centre pour garder une marge de mer
// GÉNÉREUSE : les fanions-mois mouillent au large sans jamais chevaucher la
// côte ni les portes de région. Toute ancre posée SUR l'île doit subir la
// même transformation → passer par ancrePct().
export const ILE_SCALE = 0.70;
export const ILE_CENTRE = { x: 80, y: 60 };

/** Ancres géographiques (coordonnées viewBox 160×120, AVANT ILE_SCALE). */
export const REGIONS = {
    foret: { x: 62, y: 28 },   // Roche Écrite (nord, sous Saint-Denis) — Forêt des Mots
    volcan: { x: 108, y: 86 }, // Piton de la Fournaise (SE) — Volcan des Nombres
    piton: { x: 76, y: 58 },   // Piton des Neiges (centre)
    nid: { x: 42, y: 42 },     // nid de Tano (ouest de la Roche Écrite)
    lagon: { x: 29, y: 62 },   // lagon de l'Ermitage (côte ouest)
};

/**
 * Convertit une ancre viewBox en position % du conteneur (left/top),
 * en appliquant la réduction ILE_SCALE autour du centre — pour positionner
 * des éléments HTML (portes de région, nid) EXACTEMENT sur la carte SVG.
 */
export const ancrePct = ({ x, y }) => {
    const sx = ILE_CENTRE.x + (x - ILE_CENTRE.x) * ILE_SCALE;
    const sy = ILE_CENTRE.y + (y - ILE_CENTRE.y) * ILE_SCALE;
    return { left: (sx / 160) * 100, top: (sy / 120) * 100 };
};

/** Décor SVG minimal (coordonnées viewBox, à rendre DANS le groupe scale). */
export const DECOR = {
    // Les 3 cirques (Mafate NO, Salazie NE, Cilaos S) — creux subtils autour
    // du Piton des Neiges.
    cirques: [
        { cx: 62, cy: 50, rx: 9, ry: 7 },
        { cx: 84, cy: 46, rx: 8, ry: 6 },
        { cx: 74, cy: 68, rx: 8, ry: 7 },
    ],
    // Cône du volcan (triangle + cratère) au Piton de la Fournaise.
    volcanCone: 'M100,92 L108,78 L116,92 Z',
    volcanCratere: { cx: 108, cy: 81, rx: 2.6, ry: 1.3 },
};
